// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33Qjm","colBig":"styles_colBig__32fG-","colSmall":"styles_colSmall__1Z6mz"};